import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { Checkbox } from '@schibsted-svp/react-ui';
import get from 'lodash/get';

import type { ChangeEvent, FC } from 'react';

import styles from './SubscriptionsCheckbox.module.scss';

const options = [
  { label: 'Sport', name: 'sport' },
  { label: 'Plus', name: 'plus' },
];

type SubscriptionsCheckboxProps = {
  name: string;
  checkedAccessFilter?: string;
};

export const SubscriptionsCheckbox: FC<SubscriptionsCheckboxProps> = ({
  name,
}) => {
  const { setFieldValue, values } = useFormikContext();

  const value = get(values, name) as string;
  const subscription = useMemo(() => (value ? value.split(',') : []), [value]);

  function onChange(
    event: ChangeEvent<HTMLInputElement>,
    checkboxName: string
  ) {
    const { checked } = event.target;
    if (checked) {
      const newSubscription = [...subscription, checkboxName];
      setFieldValue(name, newSubscription.join(','));
    } else {
      const newSubscription = subscription.filter((a) => a !== checkboxName);
      setFieldValue(
        name,
        newSubscription.join(',') ? newSubscription.join(',') : undefined
      );
    }
  }

  return (
    <div className={styles.container}>
      {options.map((checkbox) => (
        <Checkbox
          label={checkbox.label}
          key={checkbox.label}
          checked={subscription.includes(checkbox.name)}
          onChange={(event) => onChange(event, checkbox.name)}
        />
      ))}
    </div>
  );
};
